/**
 * @description: Message Type Enum
 */
export const MessageEnum = {
  NONE: 'none',
  MESSAGE: 'message',
  MODAL: 'modal'
}

